module.exports = __webpack_public_path__ + "img/2_114.966061ee.png";